(function ($) {
    $('input[name="s"]').on('input', function (e) {
        var target = $(e.target);
        if (target.val().length > 3) {
            var query = target.val();

            $.ajax({
                url: sd_search.url,
                data: {
                    action: sd_search.action,
                    nonce: sd_search.nonce,
                    s: query, 
                },
                success: function (data, status, jqxhr) {
                    $('.autocomplete-target').html(data);
                },
                error: function (jqxhr, status, error) {
                    $('.autocomplete-target').html("");
                }
            })
        } else {
            $('.autocomplete-target').html("");
        }
    })

})(jQuery);